import SmsTokenButtonController from './sms-token-button-controller'

export default SmsTokenButtonController
